import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-details-accordion" }

import { computed, inject, markRaw } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';

import Accordion, { AccordionItem } from '@/components/Accordion/Accordion.vue';
import ProductDetailsAccordionDescription from './ProductDetailsAccordionDescription.vue';
import ProductDetailsAccordionPerformanceAttributes from './ProductDetailsAccordionPerformanceAttributes.vue';
import ProductDetailsAccordionSize from './ProductDetailsAccordionSize.vue';
import ProductDetailsAccordionFit from './ProductDetailsAccordionFit.vue';
import ProductDetailsAccordionFunctions from './ProductDetailsAccordionFunctions.vue';
import ProductDetailsAccordionMaterialAndCare from './ProductDetailsAccordionMaterialAndCare.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordion',
  setup(__props) {

const { websiteText } = useWebsiteTexts();

const rawComponents = {
  description: markRaw(ProductDetailsAccordionDescription),
  performanceAttributes: markRaw(ProductDetailsAccordionPerformanceAttributes),
  size: markRaw(ProductDetailsAccordionSize),
  fit: markRaw(ProductDetailsAccordionFit),
  functions: markRaw(ProductDetailsAccordionFunctions),
  materialAndCare: markRaw(ProductDetailsAccordionMaterialAndCare),
};
const product = inject('product') as any;
const pdpDetails = inject('pdpDetails') as any;
const items = computed<AccordionItem[]>(() => getInitialAccordionItems());

function getInitialAccordionItems() {
  const initialItems: AccordionItem[] = [];

  initialItems.push(getDescriptionItem());
  initialItems.push(getSizeItem());

  if (product.value?.fitInfo.label) {
    initialItems.push(getFitItem());
  }
  if (product.value.productFunctions.length > 0) {
    initialItems.push(getFunctionsItem());
  }

  initialItems.push(getMaterialAndCareItem(), ...getVisualScalesItems());
  return initialItems;
}

function createAccordionItem(config: Partial<AccordionItem>) {
  return {
    title: config.title || '',
    content: config.content || null,
    component: config.component || {},
  };
}

function getDescriptionItem() {
  const title =
    websiteText('productdetails_descriptiontab').value || 'Description';
  return createAccordionItem({
    title: title,
    component: rawComponents.description,
  });
}

function getVisualScalesItems() {
  return (
    pdpDetails.value?.description?.visualScales?.map((scale: any) => {
      return createAccordionItem({
        title: scale.heading,
        content: {
          title: scale.scaleShortDescription,
          description: scale.infoText,
          imageUrl: scale.scaleImageUrl,
        },
        component: rawComponents.performanceAttributes,
      });
    }) || []
  );
}

function getSizeItem() {
  const title = websiteText('sizeguide__title').value;
  return createAccordionItem({
    title: title,
    component: rawComponents.size,
  });
}

function getFitItem() {
  const title = websiteText('productdetails_fittab').value;
  return createAccordionItem({
    title: title,
    component: rawComponents.fit,
  });
}

function getFunctionsItem() {
  const title = websiteText('product__functions_tab').value;
  return createAccordionItem({
    title: title,
    component: rawComponents.functions,
  });
}

function getMaterialAndCareItem() {
  const title = `${websiteText('productdetails_materialstab').value} & ${
    websiteText('productdetails_careguidetab').value
  }`;
  return createAccordionItem({
    title: title,
    component: rawComponents.materialAndCare,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Accordion, {
      items: _unref(items),
      singleExpand: true
    }, null, 8, ["items"])
  ]))
}
}

})